import { Injectable } from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import { environment } from '../../../environments/environment';
// import { JwtService } from './jwt.service';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { UserService } from '../User/user.service';
import { JwtTokenService } from '../JwtToken/jwt-token.service';
import {catchError} from "rxjs/operators";
import {Router} from "@angular/router";

// S195 / P405: the ONLY replies that mean "log in again". They are the plain-text
// 400s sent by the backend login check, api/policies/isAuth.js lines 20, 22, 27, 93.
// If one of those messages is reworded there, change it here too.
const SESSION_REPLIES = [
  'Session timed out, please login again',
  'Error authenticating, please login again',
  'User not found / Session Expired',
  'No token provided',
];


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // public httpOptions = {
  //   headers: new HttpHeaders({
  //     // 'Content-Type': 'application/json',
  //     'authorization' : `bearer ${this.jwtTokenService.getWebToken()}`
  //   })
  // };

  userDetails: any;
  constructor(
    private http: HttpClient,
    private jwtTokenService: JwtTokenService,
    private router: Router,
  ) {
  }

  private handleError(error: any): Observable<never> {
    if (error.status === 400) {
      if (error.url?.includes('/User/loginUser') && error.error) {
        return throwError(() => error.error);
      } else if (error.error?.message) {
        return throwError(() => error.error.message);
      } else if (!SESSION_REPLIES.includes(error.error)) {
        // S195 / P405: any other refusal is the screen's to show, once, as sent.
        // Before S195 every 400 without a message logged the user out.
        return throwError(() => error.error || 'The request was refused.');
      } else {
        // S194 / P405: when a login expires, every request a screen fires
        // fails at once, and each used to raise its own pop-up (four OKs
        // on prod). The first one tells the user once and goes to login;
        // the rest never emit, so no screen shows an alert for them. The
        // flag lives on window and resets with the page load at /login.
        if ((window as any).__atSessionEnding) {
          return new Observable<never>(() => {});
        }
        (window as any).__atSessionEnding = true;
        sessionStorage.clear();
        alert('Your session has expired. Please log in again.');
        location.href = '/login';
        return new Observable<never>(() => {});
      }
    }

    console.error('HTTP Error:', error);

    const errorMessage = error.message || 'An unknown error occurred';
    return throwError(() => new Error(errorMessage));
  }


  post(path: string, body: any, customHeaders: Record<string, string> = {}): Observable<any> {
    const headers = {
      'authorization' : `bearer ${this.jwtTokenService.getWebToken()}`,
      ...customHeaders
    }
    let httpOptions = {
      headers: new HttpHeaders(headers)
    };
    return this.http.post(
      `${environment.apiUrl}${path}`, body, httpOptions
    ).pipe(catchError((error) => this.handleError(error)));
  }

  get(path: string): Observable<any> {
    // this.httpOptions.headers.set('authorization', this.jwtTokenService.getWebToken())
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization' : `bearer ${this.jwtTokenService.getWebToken()}`
      })
    };
    return this.http.get(
      `${environment.apiUrl}${path}`, httpOptions
    ).pipe(catchError((error) => this.handleError(error)));
  }

  put(path: string, param: any, body:any): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization' : `bearer ${this.jwtTokenService.getWebToken()}`
      })
    };
    return this.http.put(
      `${environment.apiUrl}${path}/${param}`, body, httpOptions
    ).pipe(catchError((error) => this.handleError(error)));
  }

  delete(path: string, param: any): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization' : `bearer ${this.jwtTokenService.getWebToken()}`
      })
    };
    return this.http.delete(
      `${environment.apiUrl}${path}/${param}`, httpOptions
    ).pipe(catchError((error) => this.handleError(error)));
  }


}
